"use strict";

var isProperFormat = require('./isProperFormat');
/**
 * Returns the latest version of a price_table beginning with version 0.
 *
 * @memberof! Pricing
 * @param {string} price_table The name of the price table to get the version for.
 * @return {number} The latest version of the price table as a number.
 * @throws {Error} When price_table is the empty string
 * @throws {Error} When price_table is null or undefined
 * @throws {Error} When price_table can't be found.
 * @throws {Error} When price_table isn't properly formatted.
 */


function getVersion(table) {
  try {
    isProperFormat(table);
  } catch (error) {
    debugger;
  }

  if (!isProperFormat(table)) {
    debugger;
    console.error(table);
    throw new Error('table is improperly formatted, doesn\'t follow v{version} convention.');
  }

  var highest_version = 0;

  while (table["v".concat(highest_version + 1)]) {
    highest_version++;
  }

  return highest_version;
}

module.exports = getVersion;